import React, { useEffect, useState } from 'react';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import { imageUrl } from '@helpers/image';
import S from './NavigationDropdown.styles';
import { responsiveSizes } from '@helpers/responsive';
const NavigationItem = ({ description, bgImage, external, isActive = false, tabIndex = 0, title, url, children, onActive, onInactive, }) => {
    return (React.createElement(S.Item, { onMouseEnter: () => {
            onActive && onActive();
        } },
        React.createElement(S.Link, { href: url, isActive: isActive, isExternal: external ? true : false, tabIndex: tabIndex, hasImage: bgImage ? true : false, target: external ? '_blank' : '_self', onKeyDown: (event) => {
                if (event.key.toLowerCase() === 'arrowright') {
                    event.preventDefault();
                    onActive && onActive();
                }
                if (event.key.toLowerCase() === 'arrowleft') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
                if (event.key.toLowerCase() === 'escape') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
            } },
            bgImage && (React.createElement(S.BgImageHolder, null,
                React.createElement(S.BgImage, { alt: bgImage.altText, draggable: false, loading: "lazy", role: "presentation", src: imageUrl(bgImage, {}), sizes: [`25vw`].join(', '), srcSet: responsiveSizes([{ value: 25 }], bgImage, { heightRatio: 95 / 124 }) }))),
            React.createElement(S.ContentHolder, null,
                title,
                description && React.createElement(S.LinkDescription, null, description)),
            children && React.createElement(S.Chevron, null),
            external && !children && React.createElement(S.External, null))));
};
const NavigationDropdown = ({ areaTitle, areaUrl, isActive, items = [], mode, promo: defaultPromo, }) => {
    const [activeLevel1Id, setActiveLevel1Id] = useState('');
    const [activeLevel2Id, setActiveLevel2Id] = useState('');
    // Get the active item for each level.
    const level1Item = items.find((item) => item.id === activeLevel1Id);
    const level2Item = level1Item?.children?.find((item) => item.id === activeLevel2Id);
    // Get the promo from the lowest level active item.
    const activePromo = level2Item?.promo ?? level1Item?.promo ?? defaultPromo;
    // Reset active selection when dropdown is hidden.
    useEffect(() => {
        if (!isActive) {
            setActiveLevel1Id('');
            setActiveLevel2Id('');
        }
    }, [isActive]);
    return (React.createElement(S.Container, { mode: mode, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
            closed: {
                opacity: 0,
                transitionEnd: {
                    visibility: 'hidden',
                },
                transition: {
                    type: 'tween',
                    ease: 'easeOut',
                },
            },
            opened: {
                opacity: 1,
                visibility: 'visible',
                transition: {
                    type: 'tween',
                    ease: 'easeOut',
                },
            },
        }, onKeyDown: (event) => {
            if (event.key.toLowerCase() === 'escape') {
                if (activeLevel2Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel2Id('');
                    return;
                }
                if (activeLevel1Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel1Id('');
                    return;
                }
            }
        } },
        React.createElement(SiteWide, null,
            React.createElement(S.DropDownTop, null,
                React.createElement(S.AreaLink, { href: areaUrl, key: areaUrl },
                    areaTitle,
                    " Page")),
            React.createElement(S.Inner, null,
                renderColumn1(),
                renderColumn2(),
                renderColumn3()))));
    function renderColumn1() {
        return (React.createElement(S.Column1, null,
            React.createElement(S.List, null, items.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isActive: activeLevel1Id === item.id, tabIndex: isActive && (!activeLevel1Id || activeLevel1Id === item.id) ? 0 : -1, onActive: () => {
                    setActiveLevel1Id(item.id);
                    setActiveLevel2Id('');
                }, onInactive: () => {
                    setActiveLevel1Id('');
                    setActiveLevel2Id('');
                } }))))));
    }
    function renderColumn2() {
        return items.map((item) => {
            if (!item.children) {
                return null;
            }
            const isActive = activeLevel1Id === item.id;
            return (React.createElement(S.Column2, { key: item.id, isActive: isActive, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
                    closed: {
                        opacity: 0,
                        transitionEnd: {
                            visibility: 'hidden',
                        },
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                    opened: {
                        opacity: 1,
                        visibility: 'visible',
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                } },
                React.createElement(S.List, null, item.children.map((child) => (React.createElement(NavigationItem, { key: child.id, ...child, isActive: activeLevel2Id === child.id, tabIndex: activeLevel1Id === item.id && (!activeLevel2Id || activeLevel2Id === child.id)
                        ? 0
                        : -1, onActive: () => {
                        setActiveLevel2Id(child.id);
                    }, onInactive: () => {
                        setActiveLevel2Id('');
                    } }))))));
        });
    }
    function renderColumn3() {
        if (!activePromo) {
            return null;
        }
        return (React.createElement(S.Column3, { isActive: true }, activePromo.image && (React.createElement(S.PromoImageWrapper, null,
            React.createElement(S.BgImage, { alt: activePromo.image.altText, draggable: false, loading: "lazy", role: "presentation", src: imageUrl(activePromo.image, {}) })))));
    }
};
export default NavigationDropdown;
